/**
 * Synchronous Redux action creators for Recent Deals feature.
 * These creators dispatch plain actions for UI state changes such as hiding the recent deals panel,
 * redirecting to the deal list, opening a deal, or selecting a deal.
 * No side effects or async logic should be included here.
 */
import {
    SHOW_RECENT_DEALS,
    HIDE_RECENT_DEALS,
    REDIRECT_TO_DEAL_LIST,
    OPEN_RECENT_DEAL,
    SELECT_DEAL,
    CREATE_QUOTE
} from './actions';
import type { OpenInTarget } from '../enum/common.enum';

export const showRecentDeals = () => ({
    type: SHOW_RECENT_DEALS
});

export const hideRecentDeals = () => ({
    type: HIDE_RECENT_DEALS
});

export const redirectToDealList = () => ({
    type: REDIRECT_TO_DEAL_LIST
});

export const openDeal = (dealId?: string, target?: OpenInTarget) => ({
    type: OPEN_RECENT_DEAL,
    payload: { dealId, target }
});

export const selectDeal = (dealId: string) => ({
    type: SELECT_DEAL,
    payload: { dealId }
});

export const createQuote = (coOrgId?: string) => ({
    type: CREATE_QUOTE,
    payload: { coOrgId }
});
